import { ShareOutlineIcon } from '@ikyucom/design-system-icons-react'
import { useCallback } from 'react'
import { getFragmentData } from '~/lib/graphql'
import { planDetailPagePath } from '~/lib/path/path'
import { IconButton } from '~/ui/IconButton'
import type { SharePlanProps } from '../SharePlanFragment'
import { SharePlanFragment } from '../SharePlanFragment'
import { useWebShareSupported } from '../useWebShareSupported'

export function SharePlanButton({ plan }: SharePlanProps) {
  const {
    planId,
    restaurant: { restaurantId },
  } = getFragmentData(SharePlanFragment, plan)

  const webShareSupported = useWebShareSupported()

  const onClick = useCallback(() => {
    navigator
      .share({
        url: planDetailPagePath(restaurantId, planId),
      })
      .catch()
  }, [restaurantId, planId])

  return webShareSupported ? (
    <IconButton
      size="sm"
      theme="filled"
      Icon={ShareOutlineIcon}
      css={{ justifyContent: 'center' }}
      onClick={onClick}
      aria-label="このプラン情報を共有する"
    />
  ) : null
}
